import React, {useCallback, useEffect} from 'react';
import styled, {css} from 'styled-components';
import * as braze from '@braze/web-sdk';
import {useDispatch, useSelector} from 'react-redux';
import {selectPushEnabled} from '../../store/reducers';
import {togglePush} from '../../store/actions/user';
import {useTranslation} from 'react-i18next';

const FollowButton = ({visible}) => {
    const pushEnabled = useSelector(selectPushEnabled);
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const _toggleSelected = useCallback(() => {
        if (pushEnabled) {
            dispatch(togglePush(false));
            braze.getUser().setPushNotificationSubscriptionType('unsubscribed');
        } else if (!braze.isPushPermissionGranted()) {
            braze.requestPushPermission(() => {
                dispatch(togglePush(true));
                braze
                    .getUser()
                    .setPushNotificationSubscriptionType('subscribed');
            });
        } else {
            braze.getUser().setPushNotificationSubscriptionType('subscribed');
            dispatch(togglePush(true));
        }
    }, [dispatch, pushEnabled]);

    useEffect(() => {
        var interval;
        if (visible) {
            interval = setInterval(() => {
                if (
                    (braze.isPushBlocked() ||
                        !braze.isPushPermissionGranted()) &&
                    pushEnabled
                ) {
                    dispatch(togglePush(false));
                }
            }, 1000);
        }
        return () => {
            clearInterval(interval);
        };
    }, [visible, pushEnabled, dispatch]);

    return (
        <Container onClick={_toggleSelected} isFollowing={pushEnabled}>
            <FollowText>
                {pushEnabled ? t('push.followingCTA') : t('push.idleCTA')}
            </FollowText>
            <NotifyImage
                src={
                    pushEnabled
                        ? require('../../assets/ic_tick.png')
                        : require('../../assets/ic_notify.png')
                }
            />
        </Container>
    );
};

const Container = styled.div`
    height: 35px;
    background-color: black;
    border-radius: 4px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    display: flex;
    cursor: pointer;
    padding: 0px 12px;
    ${props =>
        props.isFollowing &&
        css`
            background: linear-gradient(90deg, #70bfa6 0%, #00aeef 100%);
        `};
`;

const FollowText = styled.span`
    font-family: AvenirNextRoundedStd;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    color: white;
    padding-horizontal: 12px;
`;

const NotifyImage = styled.img`
    margin-horizontal: 12px;
`;

export default FollowButton;
